export default {
    //get all SUBJECT_ASSIST_PHONES
    GET_SUBJECT_ASSIST_PHONES_REQUEST: 'GET_SUBJECT_ASSIST_PHONES_REQUEST',
    GET_SUBJECT_ASSIST_PHONES_SUCCESS: 'GET_SUBJECT_ASSIST_PHONES_SUCCESS',
    GET_SUBJECT_ASSIST_PHONES_FAIL: 'GET_SUBJECT_ASSIST_PHONES_FAIL',

    //edit SUBJECT_ASSIST_PHONE
    EDIT_SUBJECT_ASSIST_PHONE_REQUEST: 'EDIT_SUBJECT_ASSIST_PHONE_REQUEST',
    EDIT_SUBJECT_ASSIST_PHONE_SUCCESS: 'EDIT_SUBJECT_ASSIST_PHONE_SUCCESS',
    EDIT_SUBJECT_ASSIST_PHONE_FAIL: 'EDIT_SUBJECT_ASSIST_PHONE_FAIL',

    //create SUBJECT_ASSIST_PHONE
    CREATE_SUBJECT_ASSIST_PHONE_REQUEST: 'CREATE_SUBJECT_ASSIST_PHONE_REQUEST',
    CREATE_SUBJECT_ASSIST_PHONE_SUCCESS: 'CREATE_SUBJECT_ASSIST_PHONE_SUCCESS',
    CREATE_SUBJECT_ASSIST_PHONE_FAIL: 'CREATE_SUBJECT_ASSIST_PHONE_FAIL',

    DELETE_SUBJECT_ASSIST_PHONE_REQUEST: 'DELETE_SUBJECT_ASSIST_PHONE_REQUEST',
    DELETE_SUBJECT_ASSIST_PHONE_SUCCESS: 'DELETE_SUBJECT_ASSIST_PHONE_SUCCESS',
    DELETE_SUBJECT_ASSIST_PHONE_FAIL: 'DELETE_SUBJECT_ASSIST_PHONE_FAIL',

    //loading
    ADD_SUBJECT_ASSIST_PHONES_LOADING: 'ADD_SUBJECT_ASSIST_PHONES_LOADING'
};

